import { useLogger } from '../composables/useLogger'

const logger = useLogger()

const isDev = import.meta.env.VITE_DEV === 'true'
const useEmulator = import.meta.env.VITE_USE_EMULATOR === 'true'
const useDbTest = import.meta.env.VITE_DB_TEST === 'true'

logger.info('Variables de entorno', {
  component: 'Environment',
  method: 'initialize',
  data: {
    VITE_DEV: import.meta.env.VITE_DEV,
    VITE_DB_TEST: import.meta.env.VITE_DB_TEST,
    VITE_USE_EMULATOR: import.meta.env.VITE_USE_EMULATOR,
    VITE_FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    isDev,
    useEmulator,
    useDbTest,
  },
})

export interface EnvironmentConfig {
  isDevelopment: boolean
  firebase: {
    apiKey: string
    authDomain: string
    projectId: string
    storageBucket: string
    messagingSenderId: string
    appId: string
  }
  functions: {
    url: string
    useEmulator: boolean
  }
  useEmulator: boolean
  useDbTest: boolean
}

// Validar variables de entorno requeridas
const requiredEnvVars = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_STORAGE_BUCKET',
  'VITE_FIREBASE_MESSAGING_SENDER_ID',
  'VITE_FIREBASE_APP_ID',
]

const missingVars = requiredEnvVars.filter(varName => !import.meta.env[varName])
if (missingVars.length > 0) {
  const error = `Faltan variables de entorno requeridas: ${missingVars.join(', ')}`
  logger.error(error, {
    component: 'Environment',
    method: 'initialize',
    data: { missingVars },
  })
  throw new Error(error)
}

const environment: EnvironmentConfig = {
  isDevelopment: isDev,
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  },
  functions: {
    url: useEmulator
      ? 'http://127.0.1:5001/accyon/us-central1/app'
      : 'https://us-central1-consultoriaenaccyon.cloudfunctions.net/app',
    useEmulator,
  },
  useEmulator,
  useDbTest,
}

const FIRESTORE_JOBS_COLLECTION = useDbTest ? 'test_jobs' : 'jobs'
const STORAGE_JOBS_FOLDER = useDbTest ? 'test_jobs' : 'jobs'
const FIRESTORE_CONTACTS_COLLECTION = useDbTest ? 'test_contacts' : 'contacts'
const FIRESTORE_JOB_APPLICANTS_COLLECTION = useDbTest ? 'test_jobApplicants' : 'jobApplicants'
const FIRESTORE_JOB_BOARD_COLLECTION = useDbTest ? 'test_jobBoard' : 'jobBoard'
const FIRESTORE_CONFIG_COLLECTION = useDbTest ? 'test_config' : 'config'

logger.info('Configuración de entorno', {
  component: 'Environment',
  method: 'initialize',
  data: {
    useEmulator: environment.useEmulator,
    isDevelopment: environment.isDevelopment,
    projectId: environment.firebase.projectId,
    FIRESTORE_JOBS_COLLECTION,
    STORAGE_JOBS_FOLDER,
    FIRESTORE_JOB_BOARD_COLLECTION,
    FIRESTORE_CONTACTS_COLLECTION,
    FIRESTORE_JOB_APPLICANTS_COLLECTION,
    FIRESTORE_CONFIG_COLLECTION,
  },
})

// Kontrola ATS Integration Configuration
export const KONTROLA_CONFIG = {
  apiUrl: import.meta.env.VITE_KONTROLA_API_URL || '',
  apiKey: import.meta.env.VITE_KONTROLA_API_KEY || '',
  enabled: !!(import.meta.env.VITE_KONTROLA_API_URL && import.meta.env.VITE_KONTROLA_API_KEY),
}

logger.info('Kontrola Configuration', {
  component: 'Environment',
  method: 'initialize',
  data: {
    enabled: KONTROLA_CONFIG.enabled,
    apiUrlConfigured: !!KONTROLA_CONFIG.apiUrl,
    apiKeyConfigured: !!KONTROLA_CONFIG.apiKey,
  },
})

export {
  FIRESTORE_JOBS_COLLECTION,
  STORAGE_JOBS_FOLDER,
  FIRESTORE_CONTACTS_COLLECTION,
  FIRESTORE_JOB_APPLICANTS_COLLECTION,
  FIRESTORE_JOB_BOARD_COLLECTION,
  FIRESTORE_CONFIG_COLLECTION,
}
export default environment
